import { render, staticRenderFns } from "./BoilerManufacturerForm.vue?vue&type=template&id=b0ba69a4"
import script from "./BoilerManufacturerForm.vue?vue&type=script&lang=js"
export * from "./BoilerManufacturerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports